import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react/lib/Image';
import {
  internalLinkStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getTutorialStepsStyles = (_, { palette = {} }) => ({
  tutorContent: {
    marginBottom: 10,
    ...internalLinkStyle({ palette, isGreyBackground: true }),
  },
  imageContent: {},
});

const getNewTutorialStepsStyles = (_, { palette = {} }) => ({
  tutorContent: {
    marginBottom: 10,
    ...internalLinkStyle({ palette, isGreyBackground: true }),
  },
  imageContent: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 30,
  },
});

const TutorialStep = (props) => {
  const {
    title,
    descTemp,
    imageSrc,
    classes,
    i18n,
  } = props;

  return (
    <div>
      <h6>{title}</h6>
      <div className={classes.tutorContent}>
        {descTemp}
      </div>
      {imageSrc ? <Image alt={i18n.getString(_TL_('tutorial step image'))} src={imageSrc} className={classes.imageContent} /> : ''}
    </div>
  );
};

TutorialStep.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.string.isRequired,
  descTemp: PropTypes.element,
  imageSrc: PropTypes.string,
};

TutorialStep.defaultProps = {
  descTemp: null,
  imageSrc: '',
};

export const StyledTutorialStep = withDefaultStyles(
  TutorialStep,
  getTutorialStepsStyles
);

export const NewStyledTutorialStep = withDefaultStyles(
  TutorialStep,
  getNewTutorialStepsStyles
);
